import { socialMediaEnum } from '../enums/social-media.enum';

export const socialMediaConstant = {
  [socialMediaEnum.FACEBOOK]: {
    prefixUrl: 'https://www.facebook.com/',
    icon: 'assets/icons/socials/facebook.svg',
  },
  [socialMediaEnum.WEBSITE]: {
    prefixUrl: 'https://www.example.com/',
    icon: 'assets/icons/socials/website.svg',
  },
  [socialMediaEnum.LINKEDIN]: {
    prefixUrl: 'https://www.linkedin.com/in/',
    icon: 'assets/icons/socials/linkedIn.svg',
  },
  [socialMediaEnum.INSTAGRAM]: {
    prefixUrl: 'https://www.instagram.com/',
    icon: 'assets/icons/socials/instagram.svg',
  },
  [socialMediaEnum.TWITTER]: {
    prefixUrl: 'https://twitter.com/',
    icon: 'assets/icons/socials/x-icon.svg',
  },
  [socialMediaEnum.THREADS]: {
    prefixUrl: 'https://www.threads.net/',
    icon: 'assets/icons/socials/threads.svg',
  },
  [socialMediaEnum.TELEGRAM]: {
    prefixUrl: 'https://t.me/',
    icon: 'assets/icons/socials/telegram.svg',
  },
  [socialMediaEnum.DISCORD]: {
    prefixUrl: 'https://discord.com/invite/',
    icon: 'assets/icons/socials/discord.svg',
  },
  [socialMediaEnum.MAIL]: {
    prefixUrl: '',
    icon: 'assets/icons/socials/mail.svg',
  },
  [socialMediaEnum.PINTEREST]: {
    prefixUrl: '',
    icon: 'assets/icons/socials/pinterest.svg',
  },
};
